import { render, staticRenderFns } from "./RevisionIndiceValueCreate.vue?vue&type=template&id=4aacfe3c&scoped=true"
import script from "./RevisionIndiceValueCreate.vue?vue&type=script&lang=js"
export * from "./RevisionIndiceValueCreate.vue?vue&type=script&lang=js"
import style0 from "./RevisionIndiceValueCreate.vue?vue&type=style&index=0&id=4aacfe3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aacfe3c",
  null
  
)

export default component.exports